<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :editIcon="editIcon"
    :readIcon="readIcon"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag'
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readIcon: {
      type: String,
      default: "mdi-eye"
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: OUTBOUND_NFE_TAXATION_RULE_EDIT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.outboundNfeTaxationRule;
          this.extraData = response.data.globalContext;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(taxationRule) {
      // console.log("Edit taxationRule ", taxationRule, taxationRule.validations, this.deepFilterEntryWithAllowedFieldsForMutation(taxationRule, taxationRule.validations))
      this.pageLoading = true;
      // console.log(taxationRule)
      this.$apollo
        .mutate({
          mutation: UPDATE_OUTBOUND_NFE_TAXATION_RULE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(taxationRule, taxationRule.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateTaxationRule.errors
          // console.log(errors)
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const OUTBOUND_NFE_TAXATION_RULE_EDIT_QUERY = gql `
  query ($id: ID!) {
    accountContext{
      outboundNfeTaxationRule(id: $id) {
        id
        taxationGroup {
          id
          name
          ncm {
            id
            text
          }
        }
        ibsCbsCstId
        ibsCbsCclasstribId
        taxRegimeType
        taxRegimeTypeName
        operationDestinationTypeName
        icmsOriginId
        icmsCstId
        icmsCsosnId
        icmsVbcStRet
        icmsPst
        icmsVicmsSubstituto
        icmsVicmsStRet
        icmsVbcFcpStRet
        icmsPfcpStRet
        icmsVfcpStRet
        icmsPredBcEfet
        icmsPicmsEfet
        icmsModBcId
        icmsPredBc
        icmsPdif
        icmsModBcStId
        icmsPmvaSt
        icmsPredBcSt
        icmsPicmsSt
        icmsPfcp
        icmsPfcpSt
        icmsVicmsDeson
        icmsMotDesonId
        icmsPcredSn
        icmsVcredIcmsSn
        pisCstId
        pisPpis
        pisValiqProd
        cofinsCstId
        cofinsPcofins
        cofinsValiqProd
        validations
        extraValidations
      }
    }
    globalContext{
      allIcmsOrigins {
        value: id
        text
      }
      allIcmsCsts {
        value: id
        text
      }
      allIcmsCsosns {
        value: id
        text
      }
      allIcmsModBcs {
        value: id
        text
      }
      allIcmsModBcSts {
        value: id
        text
      }
      allPisCsts {
        value: id
        text
      }
      allCofinsCsts {
        value: id
        text
      }
      allIbsCbsCsts{
        id
        text
      }
      allIcmsMotDesons {
        value: id
        text
      }
    }
  }
`

const UPDATE_OUTBOUND_NFE_TAXATION_RULE_MUTATION = gql `
mutation($input: TaxationRuleUpdateInputObject!) {
    updateTaxationRule(input: $input) {
      taxationRule{
        id
      }
      errors
    }
  }
`
</script>

<style scoped></style>
